import axios from './configAxios';

export const postNewVehicle = async (id, formData) => {
    return await axios.post(`vehicles/create/?client_id=${id}`, formData);
};
